export const useSendCode = () => {
  const COUNT_TIME = 60
  const times = ref(COUNT_TIME)
  const isSend = ref(false)
  const timer = ref()

  onBeforeUnmount(() => {
    clearInterval(timer.value)
  })

  const sendCode = () => {
    isSend.value = true

    timer.value = setInterval(() => {
      if (times.value === 0) {
        isSend.value = false
        times.value = COUNT_TIME
        clearInterval(timer.value)
        return
      }
      times.value = times.value - 1
    }, 1000)
  }

  return {
    sendCode,
    times,
    isSend,
  }
}
